import React, { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { useAuth } from '../contexts/AuthContext';
import { playSound } from '../utils/notificationSound';
import { useNavigate } from 'react-router-dom';
import './Login.css';

type LanguageCode = 'sr' | 'en' | 'de';

const languageOptions: { code: LanguageCode; label: string; flag: string }[] = [
  { code: 'sr', label: 'SR', flag: '/RS-flag.png' },
  { code: 'en', label: 'EN', flag: '/US-flag.png' },
  { code: 'de', label: 'DE', flag: '/GER-flag.png' },
];

const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [language, setLanguage] = useState<LanguageCode>('sr');
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      await login(username, password);
      playSound('loginSuccess');
      navigate('/');
    } catch (error: any) {
      setError(error.message || 'Greška pri prijavi');
      playSound('loginFailed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-container">
      <div className="login-card">
        {/* Left Side - Image Banner */}
        <div className="login-left-banner">
          <div className="login-banner-overlay">
            <h2 className="login-banner-title">THERMOWOOL</h2>
            <p className="login-banner-subtitle"></p>
          </div>
        </div>

        {/* Right Side - Login Form */}
        <div className="login-right-form">
          <div className="login-form-header">
            <div>
              <h1 className="login-welcome-title">Dobrodošli</h1>
              <p className="login-welcome-subtitle">Prijavite se email-om ili korisničkim imenom</p>
            </div>
            <div className="login-language-selector">
              <Dropdown
                value={language}
                options={languageOptions}
                optionLabel="label"
                optionValue="code"
                onChange={(e) => setLanguage(e.value as LanguageCode)}
                appendTo="self"
                className="login-language-dropdown"
                panelClassName="login-language-dropdown-panel"
                valueTemplate={(option) => {
                  const current =
                    languageOptions.find((o) => o.code === language) || languageOptions[0];
                  return (
                    <div className="login-language-value">
                      <img src={current.flag} alt={current.code} className="login-flag-icon" />
                      <span>{current.label}</span>
                    </div>
                  );
                }}
                itemTemplate={(option) => (
                  <div className="login-language-item">
                    <img src={option.flag} alt={option.label} className="login-flag-icon" />
                    <span>{option.label}</span>
                  </div>
                )}
              />
            </div>
          </div>

          {error && (
            <Message severity="error" text={error} className="login-error-message" />
          )}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="login-field">
              <label htmlFor="username">KORISNIČKO IME</label>
              <InputText
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Username/email"
                className="login-input"
                required
              />
            </div>

            <div className="login-field">
              <label htmlFor="password">LOZINKA</label>
              <Password
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Unesite lozinku"
                className="login-input"
                style={{ width: '100% !important' }}
                feedback={false}
                toggleMask
                required
              />
            </div>

            {/* <div className="login-options">
              <div className="login-remember-me">
                <Checkbox
                  inputId="remember"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.checked || false)}
                />
                <label htmlFor="remember" className="login-remember-label">Zapamti me</label>
              </div>
              <button type="button" className="login-forgot-link">
                Zaboravljena lozinka?
              </button>
            </div> */}

            <Button 
              type="submit"
              label="PRIJAVI SE"
              loading={loading}
              className="login-submit-button"
            />

            <div className="login-divider">
            </div>

            {/* <div className="login-social-buttons">
              <button type="button" className="login-social-btn">
                <span className="login-social-icon">G</span>
              </button>
              <button type="button" className="login-social-btn">
                <i className="pi pi-apple" />
              </button>
              <button type="button" className="login-social-btn">
                <span className="login-social-icon">f</span>
              </button>
            </div> */}

            {/* <div className="login-register-link">
              Nemate nalog? <button type="button" className="login-register-btn">Registrujte se</button>
            </div> */}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
